import { useState } from 'react'
import Modal from 'react-bootstrap/Modal'
import Form from 'react-bootstrap/Form'
import { Alert, Button } from 'react-bootstrap'
import { contactSeller } from '../../../lib/functions.helper'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCheckCircle } from '@fortawesome/free-solid-svg-icons'
import PhoneInput, { isValidPhoneNumber } from 'react-phone-number-input'
import 'react-phone-number-input/style.css'

const ProductContactModal = ({ show, onHide, itemId, storeId }) => {
  const [ message, setMessage ] = useState('')
  const [ phoneNumber, setPhoneNumber ] = useState('')
  const [ email, setEmail ] = useState('')
  const [ status, setStatus ] = useState({ message: null, isError: false })
  const [ isSending, setIsSending ] = useState(false)
  const [ isSent, setIsSent ] = useState(false)
  const [ messageVisible, setMessageVisible ] = useState(false)

  const isValidEmail = (email: string) => {
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)
  }

  const handleSubmit = async (e) => {
    e.preventDefault()
    const submitedEmail = email.trim()
    const submitedPhoneNumber = phoneNumber.trim()

    if (!submitedEmail && !submitedPhoneNumber) {
      return setStatus({
        message: 'Please enter contact information.',
        isError: true
      })
    }

    if (submitedPhoneNumber && !isValidPhoneNumber(submitedPhoneNumber)) {
      return setStatus({
        message: 'Please enter a valid phone number.',
        isError: true
      })
    }

    if (submitedEmail && !isValidEmail(submitedEmail)) {
      return setStatus({
        message: 'Please enter a valid email.',
        isError: true
      })
    }

    setIsSending(true)
    await contactSeller(itemId, storeId, message, submitedPhoneNumber, submitedEmail)

    setMessage('')
    setPhoneNumber('')
    setEmail('')
    setIsSending(false)
    setIsSent(true)
  }

  return (
    <Modal
      show={show}
      onHide={onHide}
      centered
    >
      <Modal.Header closeButton className={'px-4 py-4'}>
        <Modal.Title>Contact Seller</Modal.Title>
      </Modal.Header>
      <Modal.Body className={'p-4'}>
        {isSent && (
          <div className={'p-5 br-3 d-flex flex-column gap-2 bg-light align-items-center'}>
            <div className={'text-success display-3'}>
              <FontAwesomeIcon
                icon={faCheckCircle}
                width={72}
                height={72}
                fixedWidth
              />
            </div>
            <div className={'fs-5'}>
              Message successfully sent!
            </div>
          </div>
        )}

        {!isSent && (
          <>
            {status.message && (
              <Alert variant={status.isError ? 'danger' : 'success'}>{status.message}</Alert>
            )}
            <Form onSubmit={handleSubmit}>
              <Form.Group
                className="mb-4"
                controlId="contactForm.phoneNumber"
              >
                <Form.Label>Your phone number</Form.Label>
                <PhoneInput
                  inputComponent={Form.Control}
                  defaultCountry='US'
                  countryOptionsOrder={['US', 'CA']}
                  placeholder='(321) 123-1201'
                  value={phoneNumber}
                  disabled={isSending}
                  onChange={value => setPhoneNumber(value)}
                  className='mb-3'
                />
              </Form.Group>
              <Form.Group
                className="mb-3"
                controlId="contactForm.email"
              >
                <Form.Label>Your email</Form.Label>
                <Form.Control
                  type="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  placeholder="johndoe@email.com"
                />
              </Form.Group>

              {messageVisible && (
                <Form.Group
                  className="mb-3"
                  controlId="contactForm.message"
                >
                  <Form.Label>Your message</Form.Label>
                  <Form.Control
                    as="textarea"
                    rows={3}
                    value={message}
                    onChange={(e) => setMessage(e.target.value)}
                  />
                </Form.Group>
              )}

              <Button
                size={'sm'}
                variant={'light'}
                onClick={() => {
                  setMessageVisible(!messageVisible)
                }}
              >
                {messageVisible ? 'No message needed' : 'Add a message'}
              </Button>
            </Form>
          </>
        )}
      </Modal.Body>

      {!isSent && (
        <Modal.Footer className={'px-4 py-4'}>
          <Button
            variant="success"
            onClick={handleSubmit}
            disabled={(!email?.trim() && !phoneNumber?.trim()) || isSending}
          >
            {isSending ? 'Sending...' : 'Send'}
          </Button>
        </Modal.Footer>
      )}
    </Modal>
  )
}

export default ProductContactModal